export default __webpack_public_path__ + "static/media/finetic-logo-light.498d9a81.png";